import { http } from "./httpServices";
import { OUTLET } from "./constants";

export function getOutlet() {
  return http.get(OUTLET, {
    params: {
      limit: 150,
      page: 1,
    },
  });
}
